// import { useEffect, useState } from "react";
// import * as Dialog from "@radix-ui/react-dialog";
// import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Link } from 'react-router-dom';
import img_head_banner_download from "../../assets/images/Head Banner Download.png";
import img_playstore from "../../assets/images/googleplay.png";
import img_appstore from "../../assets/images/appstore.png";
import img_famigo_apps from "../../assets/images/famigo-apps.png";

function ContentDownload() {

    return (
        <div>
            <div className="pt-[50px] md:pt-[64px] bg-[#F1F8FF]">
                <img src={img_head_banner_download} className="w-100" alt="FamilyMart Indonesia" />
            </div>
            <div className="px-[15px] md:px-[50px] lg:px-[70px] xl:px-[100px]">
                <div>
                    <h3 className="text-base md:text-3xl text-sky-500 text-center font-extrabold my-5">Belanja makanan & minuman favorit jadi #BEBASANTRI</h3>
                    <h3 className="text-xs md:text-2xl text-sky-500 text-center my-5">Cukup pilih, pesan, bayar, dan ambil di toko tanpa antre.<br />
                        Pakai FamiGO! sat-set, langsung GO!</h3>
                    <h3 className="text-xs md:text-2xl text-sky-500 text-center my-5">Ayo download aplikasi FamiGO! sekarang</h3>
                </div>
                <div className="flex justify-center">
                    <div><Link to="https://play.google.com/store/apps/details?id=com.familymartindonesia.fmi_app" target={"_blank"}><img src={img_playstore} className="w-[100px] md:w-[130px] lg:w-[150px] xl:w-[200px]" alt="FamilyMart Indonesia" /></Link></div>
                    <div><Link to="https://apps.apple.com/id/app/famiapps-by-familymartid/id1597478434?l=id" target={"_blank"}><img src={img_appstore} className="w-[100px] md:w-[130px] lg:w-[150px] xl:w-[200px]" alt="FamilyMart Indonesia" /></Link></div>
                </div>
                <div className='my-5'>
                    <img src={img_famigo_apps} className="w-100" alt="FamilyMart Indonesia" />
                </div>
            </div>
        </div>
    );
}

export default ContentDownload;
